// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".calendar-date__days--addition-week-days{transition:color 0s,background .3s,box-shadow .3s,opacity .3s!important;color:rgba(131,130,133,.3)!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
